export const slugify = (value: string): string => {
  const cleanedValue = value.normalize('NFD').replace(/[\u0300-\u036F]/g, '');

  return cleanedValue
    .toLowerCase()
    .replace(/[^\d\sA-Za-z-]+/g, '')
    .replace(/\s+/g, '-');
};
